var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        "formulate-input-element formulate-input-element--" + _vm.context.type,
      attrs: { "data-type": _vm.context.type }
    },
    [
      _c(
        "multiselect",
        _vm._b(
          {
            attrs: {
              "allow-empty": _vm.context.allowEmpty,
              options: _vm.context.options,
              placeholder: _vm.context.placeholder,
              "preselect-first": _vm.context.preselectFirst,
              searchable: true,
              label: "name",
              "track-by": "name",
              showLabels: false
            },
            on: {
              select: function($event) {
                return _vm.context.rootEmit("optionSelected", $event)
              }
            },
            model: {
              value: _vm.context.model,
              callback: function($$v) {
                _vm.$set(_vm.context, "model", $$v)
              },
              expression: "context.model"
            }
          },
          "multiselect",
          _vm.context.attributes,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }